$(document).ready(function() {
  $("#changeBankAccountInfoButton").on("click", function() {
    $("#currentBankAccount, #changeBankAccountInfoButton").addClass("d-none");
  })
});
